import store from '@/store'

// Vadovas VAD
// MB atstovas MBA
// MB narys MBN
// Prokuristas  PRK
// Likvidatorius LIK
// Bankroto administratorius BAN
// Įgaliotinis IGA
// Nemokumo administratorius NEM
// Tikrasis narys, paskirtas vykdyti valdymo organo pareigas TNP
// Asmuo, veikiantis religinės bendrijos vardu AVR
// Asmuo, turintis teisę naudotis el. paslaugomis ATT

const routeRole = {
  mandateSteps: ['VAD', 'MBA', 'MBN', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  subMandateSteps: ['VAD', 'MBA', 'MBN', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savMandates: ['VAD', 'MBA', 'MBN', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savMandateRefuse: ['VAD', 'MBA', 'MBN', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savMandateTerminate: ['VAD', 'MBA', 'MBN', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savMandateView: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savDocuments: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savDocumentView: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savOrders: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savNewOrder: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savOrderView: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
  savNotifications: ['VAD', 'MBA', 'MBN', 'PRK', 'LIK', 'BAN', 'IGA', 'NEM', 'TNP', 'AVR', 'ATT'],
}

export function getRouteRole(routeName) {
  return routeRole[routeName]
}
export function authSavRoute(routeName) {

  const checkSavRole = getRouteRole(routeName)
  if (!checkSavRole) {
    return true
  } 

  const userFactType = store.getters.getUserFactType
  const userFactSubType = store.getters.getUserFactSubType
  if(userFactType == '80' && userFactSubType == '80'){
      return checkSavRole.includes('PRK')
  } else {
    return true
  }

 
}
